import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/index';

const configureStore = (preloadedState, middleware) =>
  createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(thunk, ...middleware)
  );

export default configureStore;
